import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import * as constants from '@/constants';
import { Subscription } from '@/types/subscriptions/subscription';
import { SorterContainer } from '@/components/pages/Service/Detail/NONGLS/Sorter';
import { SubscriptionListContents } from '@/components/pages/Service/Detail/NONGLS/SubscriptionListContents';

type Props = {
  subscriptions: Subscription[];
  isLoading: boolean;
};

export const SubscriptionListRoot: React.FC<Props> = ({
  subscriptions,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Styled>
        <InnerWrapper>
          <Horizontal>
            <div>
              <StyledHeader>{t('pages.subscription.index.title')}</StyledHeader>
              <div className="subscription-index-sub-header">
                {t('ui.subscription.update_cancel_deadline_note', {
                  num: constants.INTERVAL_BUSINESS_DAYS + 1,
                })}
                <br />
                {t('ui.subscription.load_delay_note')}
              </div>
            </div>
            <Conditions>
              <SorterContainer />
            </Conditions>
          </Horizontal>
          <SubscriptionListContents
            subscriptions={subscriptions}
            isLoading={isLoading}
          />
        </InnerWrapper>
      </Styled>
    </Wrapper>
  );
};

const StyledHeader = styled.div`
  margin: 2em 0 1em;
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
`;

const Wrapper = styled.div`
  max-width: none;
  flex: 1 0 auto;
  width: 930px;
  padding: 0 0 48px;
  margin: 0 auto;
`;

const Horizontal = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Conditions = styled.div`
  align-self: flex-end;
  display: flex;

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

const InnerWrapper = styled.div`
  position: relative;
`;

const Styled = styled.div`
  font-size: 16px;
  line-height: 1.5;
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  max-width: none;

  @media only screen and (max-width: 767px) {
    width: auto;
    margin-left: 1em;
    margin-right: 1em;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    width: 723px;
    margin-left: auto;
    margin-right: auto;
  }

  .subscription-index-sub-header {
    color: rgba(0, 0, 0, 0.4);
    margin: -10px 0 0;
  }
`;
